import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {FeatureBuyTimesBetValue} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {HorribleHeroes} from "../HorribleHeroes";
import {HorribleHeroesParsedGameData} from "../server/data/HorribleHeroesParsedGameData";
import {HorribleHeroesParsedInitData} from "../server/data/HorribleHeroesParsedInitData";
import {IHorribleHeroesGameData} from "../server/data/IHorribleHeroesServerData";

export class FeaturePrice {
    private _featureBuyTimesBetValue: FeatureBuyTimesBetValue[] = [];
    private _wasFeatureBuy: boolean = false;
    private _totalWin: number = -1;
    private _buyFeatureName: string = "";
    private _isRestoreFeatureBet: boolean = false;

    constructor() {
        this.addEventListeners();
    }

    public isWinBelowStake(): boolean {
        return HorribleHeroes.api.gameClientConfiguration.belowStakeWinRestriction && (this.getAccumulatedRoundWin() <= this.getBuyFeaturePrice());
    }

    public reset(): void {
        this._buyFeatureName = "";
        this._isRestoreFeatureBet = false;
    }

    private addEventListeners(): void {
        HorribleHeroes.api.events.once("featureName", (data: string) => this._buyFeatureName = data);
        HorribleHeroes.api.events.once("featureBet", (data: boolean) => this._isRestoreFeatureBet = data);
        HorribleHeroes.api.events.on(APIEvent.BET, (betData: APIFeatureBetEventData) => {
            for (let index: number = 0; index < this._featureBuyTimesBetValue.length; index++) {
                if (this._featureBuyTimesBetValue[index].name === betData.featureName) {
                    this._buyFeatureName = betData.featureName;
                    break;
                }
            }
        });
        HorribleHeroes.api.events.on(APIEvent.ACTION_SPINS_BET, (betData: APIFeatureBetEventData) => {
            for (let index: number = 0; index < this._featureBuyTimesBetValue.length; index++) {
                if (this._featureBuyTimesBetValue[index].name === betData.featureName) {
                    this._buyFeatureName = betData.featureName;
                    break;
                }
            }
        });

        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    private onInitDataParsed(data: HorribleHeroesParsedInitData): void {
        this._featureBuyTimesBetValue = data.featureBuyTimesBetValue;
        this._wasFeatureBuy = false;
        this._totalWin = data.totalWin;
        EventHandler.removeEventListener(this, ServerEvent.INIT_DATA_PARSED);
    }

    private onGameDataParsed(data: HorribleHeroesParsedGameData): void {
        this._wasFeatureBuy = data.wasFeatureBuy;
        this._totalWin = data.totalWin;
    }

    private getBuyFeaturePrice(): number {
        const betLevel: string = HorribleHeroes.api.freeBets.hasFreeBets() ? HorribleHeroes.api.freeBets.getBet() : HorribleHeroes.api.betLevel.getLevel();
        let price: number = HorribleHeroes.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (this._isRestoreFeatureBet || this._wasFeatureBuy) {
            for (let index: number = 0; index < this._featureBuyTimesBetValue.length; index++) {
                if (this._featureBuyTimesBetValue[index].name === this._buyFeatureName) {
                    price *= this._featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }
    public getBuyFeaturePriceAS(response:IHorribleHeroesGameData): number {
        const betLevel: string = HorribleHeroes.api.freeBets.hasFreeBets() ? HorribleHeroes.api.freeBets.getBet() : HorribleHeroes.api.betLevel.getLevel();
        let price: number = Number(response.playedBetValue) || parseFloat(betLevel);
        if (response.wasFeatureBuy) {
            for (let index: number = 0; index < this._featureBuyTimesBetValue.length; index++) {
                if (this._featureBuyTimesBetValue[index].name === this._buyFeatureName) {
                    price *= this._featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    private getAccumulatedRoundWin(): number {
        return this._totalWin;
    }
}